import { Pipe, PipeTransform } from '@angular/core';
import { Usuario } from 'src/app/model/usuario.model';
/*
 * Takes an Usuario model and format address info
 * Usage:
 *   usuario | addressFormat:format
 * Example:
 *   {{ userData | addressFormat:'full' }}
 *   formats to: "{userData.addressName
*/
@Pipe({name: 'addressFormat'})
export class AddressFormatPipe implements PipeTransform {
  transform(user: Usuario, format?: string): string {
    if ( ! user ) {
      return "";
    }

    switch( format ) {
      case "full":
        return this.fullAddress( user );
      default:
        return this.fullAddress( user );
    }
  }

  private fullAddress( user: Usuario ): string {
    let fullAddress = user.address;

    if ( user.addressNumber ) {
      fullAddress += ` ${ user.addressNumber }`;
    }

    if ( user.addressComplement ) {
      fullAddress += ` - ${ user.addressComplement }`;
    }
    return fullAddress.trim();
  }

}
